import { MapPin, Phone, Mail } from "lucide-react";
import { LOGO, MAPS_QUERY, MAPS_PLACE_URL } from "./constants";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#2E3131] text-[#F5F6F2]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-[#F5F6F2]/10">
          <div className="md:col-span-6">
            <div className="overline text-[#E6F6CE] mb-4">Alba Immobili · Milano</div>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-[#F5F6F2]/40 mb-5">Dove siamo</div>
            <a href={MAPS_PLACE_URL} target="_blank" rel="noreferrer" data-testid="footer-map" className="flex items-start gap-3 text-[#F5F6F2]/80 hover:text-[#E6F6CE] transition-colors duration-300">
              <MapPin size={18} className="mt-1 shrink-0" /> <span>Via Cenisio 40<br />20154 Milano (MI)</span>
            </a>
            <div className="mt-4 rounded-xl overflow-hidden border border-[#F5F6F2]/10" data-testid="footer-map-embed">
              <iframe
                title="Mappa Alba Immobili — Via Cenisio 40 Milano"
                src={`https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`}
                width="100%"
                height="150"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0, filter: "grayscale(0.3) contrast(1.05)" }}
              />
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-[#F5F6F2]/40 mb-5">Contatti</div>
            <div className="space-y-3">
              <a href="tel:+393282607116" data-testid="footer-phone" className="flex items-center gap-3 text-[#F5F6F2]/80 hover:text-[#E6F6CE] transition-colors duration-300"><Phone size={17} /> 328 2607116</a>
              <a href="mailto:info@albaimmobili.it" data-testid="footer-email" className="flex items-center gap-3 text-[#F5F6F2]/80 hover:text-[#E6F6CE] transition-colors duration-300"><Mail size={17} /> info@albaimmobili.it</a>
            </div>
          </div>
        </div>

        <div className="pt-12 select-none">
          <img src={LOGO} alt="Alba Immobili" className="w-[70vw] max-w-[720px] h-auto opacity-90" />
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#F5F6F2]/40">
          <span>© {new Date().getFullYear()} Alba Immobili. Tutti i diritti riservati.</span>
          <span>Milano · Via Cenisio 40 · P.IVA 08901090962</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
